import { useState } from 'react'
import AutoComplete from '../../shared/AutoComplete'
import {
  ModuleHardware,
  TaskCodeQuery_task_codes_list_TaskCodeListItem,
  useTaskCodeQuery,
} from '~/gql/generated/graphql'

interface Props {
  onSelect: (key: string) => void
  hardwareType: ModuleHardware | null
}

interface TaskCodeSearchFieldProps extends Props {
  task_codes_list: TaskCodeQuery_task_codes_list_TaskCodeListItem[]
  loading?: boolean
}

const TaskCodeSearchField = ({
  hardwareType,
  onSelect,
  task_codes_list,
  loading,
}: TaskCodeSearchFieldProps) => {
  const [searchResult, setSearchResult] = useState<
    TaskCodeQuery_task_codes_list_TaskCodeListItem[]
  >([])

  const searchOptions = task_codes_list.filter(
    ({ vehicle_type }) => !hardwareType || vehicle_type.includes(hardwareType),
  )

  function handleSearch(inputValue: string) {
    if (inputValue.length === 0) {
      return []
    }
    const result = searchOptions.filter(option =>
      option.description.toLowerCase().includes(inputValue.toLowerCase()),
    )
    setSearchResult(result)
  }

  return (
    <AutoComplete
      placeholder="Search task code"
      onSearch={handleSearch}
      zIndex={3}
      items={searchResult.map(item => ({
        name: `${item.code} – ${item.description}`,
        key: item.code,
      }))}
      disabled={loading}
      onSelect={({ key }) => onSelect(key)}
    />
  )
}

const TaskCodeSearch = (props: Props): JSX.Element => {
  const { data, loading } = useTaskCodeQuery({ fetchPolicy: 'cache-first' })

  return (
    <TaskCodeSearchField
      {...props}
      loading={loading}
      task_codes_list={data?.task_codes_list ?? []}
    />
  )
}

export default TaskCodeSearch
